import { failure } from './errors/index.js';
export function ok(value) {
    return { ok: true, value };
}
/** Fails with a code, and optionally with the values its message needs and its field detail. */
export function err(code, extra = {}) {
    return { ok: false, failure: failure(code, extra) };
}
export function isOk(result) {
    return result.ok;
}
export function isErr(result) {
    return !result.ok;
}
/**
 * The value, or a thrown error naming the code that was refused.
 *
 * For call sites that have already established the result is ok, and for tests. It names the code
 * in the thrown message so that a misuse is diagnosable from the failure alone; it never includes
 * the details, which can name fields of a personal record.
 */
export function unwrap(result) {
    if (result.ok) {
        return result.value;
    }
    throw new Error(`unwrap() on a failed result: ${result.failure.code}`);
}
//# sourceMappingURL=result.js.map